import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { queriesPayerEngagements, queriesPayerRows } from "@query";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";
import { WSQueries } from "../../../query/WSQuery";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { usePayerEngagementHistoryResources } from "../hooks/usePayerEngagementHistoryResources";
import { getPayerEngagementUrl, PAYERS_PATH } from "../paths";

export const RoutePayerEngagementHistory: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ engagementId: string; payerId: string }>();
  const payerId = match.params.payerId;
  const engagementId = match.params.engagementId;

  // The assignment is the SDK resource; the search row is read only for the
  // client name, which the row resolves server-side.
  const queryPayerRows = queriesPayerRows.searchPayerRows.useQuery({
    filter: { id: { eq: payerId } }
  });
  const queryEngagement = queriesPayerEngagements.getPayerEngagement.useQuery({
    payerId,
    payerEngagementId: engagementId
  });

  const historyResources = usePayerEngagementHistoryResources(engagementId);

  return (
    <WSPage>
      <WSQueries queries={{ queryPayerRows, queryEngagement }}>
        {({ queryPayerRowsData, queryEngagementData }) => {
          const payerRow = queryPayerRowsData.data?.[0];

          const engagementName =
            queryEngagementData.engagementName ?? undefined;

          const payerName = payerRow ? selectorSearchRowName(payerRow) : "";

          return (
            <>
              <WSPageToolbar
                title="Assignment history"
                breadcrumbs={[
                  {
                    label: "Clients",
                    onClick: () => {
                      history.push(PAYERS_PATH);
                    }
                  },
                  {
                    label: payerName,
                    onClick: () => {
                      history.push(PAYERS_PATH + `/${payerId}`);
                    }
                  },
                  {
                    label: engagementName || "Assignment",
                    onClick: () => {
                      history.push(
                        getPayerEngagementUrl(payerId, engagementId)
                      );
                    }
                  },
                  {
                    label: "Assignment history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
